import Swiper, { EffectFade, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { gsap } from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";

class SectionHero {
  constructor(el) {
    this.DOM = el;
    this.wrapper = el.querySelector(".section-hero__wrapper");
    this.slideShow = el.querySelector(".section-hero__slideshow");

    this.parrallax();
  }
  parrallax() {
    const offset = 60;
    gsap.registerPlugin(scrollTrigger);

    gsap.to(this.slideShow, {
      yPercent: offset,
      ease: "linear",
      scrollTrigger: {
        trigger: this.DOM,
        start: `top top`,
        end: "bottom top",
        scrub: true,
      },
    });
  }

  changeHeaderMobileState() {
    if (!window.matchMedia("(max-width:991px)").matches) {
      if (this.header && this.DOM) {
        setTimeout(() => this.setElementsInWhite, 0);
        document.addEventListener("scroll", () => this.check());
      }
    }
  }

  check() {
    if (!window.matchMedia("(max-width:991px)").matches) {
      if (window.scrollY > this.DOM.clientHeight - 160) {
        this.setElementsInBlack();
      } else {
        this.setElementsInWhite();
      }
    }
  }

  setElementsInBlack() {
    this.header.isLight = false;
  }
  setElementsInWhite() {
    this.header.isLight = true;
  }

  /**
   *
   * @param {HTMLElements} items
   */
  slideShow(items) {
    const swiper = new Swiper(items, {
      modules: [EffectFade, Autoplay],
      slidesPerView: 1,
      speed: 3000,
      loop: true,
      spaceBetween: 0,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });

    if (items.length > 0) {
      swiper.autoplay = {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      };
    }
  }

  static bind() {
    const sections = document.querySelectorAll(".section-hero");
    sections.forEach((section) => new SectionHero(section));
  }
}

SectionHero.bind();
